package com.shadowings.gero.data.lessons.chapter3
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit
import gero.composeapp.generated.resources.exp_content_vocab_varie_re_basso
import gero.composeapp.generated.resources.exp_title_parole_varie

val vocabVarieWords = listOf(
    "ORZO",
    "DATTERO",
    "VIPERA",
    "LEONE",
    "RE_DEL_BASSO_EGITTO",
    "APICOLTORE"
)

fun getVocabVarieContent(words: List<Word>, languageCode: String): List<IExplanation> {
    return buildVocabContent(
        lessonTitle = Res.string.exp_title_parole_varie,
        lessonIntro = Res.string.exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit,
        wordIds = vocabVarieWords,
        words = words,
        languageCode = languageCode
    )
}

// Inscription photo (image code, word id, caption) with the word highlighted by a red box.
private val vocabVarieInscriptions = listOf(
    Triple("re_basso", "RE_DEL_BASSO_EGITTO", Res.string.exp_content_vocab_varie_re_basso),
)

fun getVocabVarieQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode
    )
    val inscriptionQuizzes = vocabVarieInscriptions.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + inscriptionQuizzes).shuffled()
}
